import Instructions from './Instructions';
import IntlWrapper from 'components/layout/intlWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import Report from './Report';
import routeUtils from 'util/routeUtils';
import toolFlow from 'helpers/toolFlow';
import {events, router} from 'lib';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {Header} from 'components/layout';
import Dealer from 'models/dealer';
import session from 'services/sessionService';
import dealerApi from 'api/dealer';

// Register in router
let render = (container, params) => {
  console.info('[UI.page.tools.accounts.verify-addresses] rendering page');
  ReactDOM.render(<IntlWrapper><VerifyAddressesTool page={params.page || 0}/></IntlWrapper>, container);
  events.publish('page-change', {page: 'tools'});
};

console.info('[UI.page.customer] register route');
router.rr.add([{path: 'tools/accounts/verify-addresses/:page', handler: routeUtils.requireAuth(render)}]);

class VerifyAddresses extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    View: PropTypes.any.isRequired,
  };

  state = {
    dealer: {
      country: 'US',
    },
  };

  componentWillMount() {
    dealerApi.getDealer(session.getUser().dealerId)
      .then(dealer => this.setState({dealer}));
  }

  render() {
    let {View} = this.props;
    let {formatMessage} = this.props.intl;

    return <div className='container'>
      <Header subTitle={formatMessage({id: 'tools.verify.account.addresses'})}
              mainTitle={formatMessage({id: 'general.accounts'})}
              mainTitleReturn='#tools/accounts'/>
      <View dealer={this.state.dealer} />
    </div>;
  }
}

const VerifyAddressesTool = injectIntl(toolFlow(VerifyAddresses, Instructions, Report));
